import React from 'react';
import { ShieldOff, LogOut } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

/**
 * DeviceBlockedPage: shown when a super admin's device fingerprint
 * is not recognized or has been revoked.
 */
const DeviceBlockedPage: React.FC = () => {
    const { logout } = useAuth();

    return (
        <div className="flex items-center justify-center min-h-screen bg-[#FAFAFA]">
            <div className="w-full max-w-md text-center space-y-6">
                {/* Icon */}
                <div className="flex justify-center">
                    <div className="w-16 h-16 rounded-full bg-red-50 flex items-center justify-center">
                        <ShieldOff className="w-8 h-8 text-red-500" />
                    </div>
                </div>

                {/* Heading */}
                <div className="space-y-2">
                    <h2 className="text-xl font-semibold text-gray-900">
                        Device Not Authorized
                    </h2>
                    <p className="text-sm text-gray-500">
                        This device is not recognized or has been revoked.
                        Contact another Super Admin to register and approve this device.
                    </p>
                </div>

                {/* Action */}
                <button
                    onClick={logout}
                    className="inline-flex items-center gap-2 text-sm text-gray-600 hover:text-gray-900 transition-colors"
                >
                    <LogOut className="w-4 h-4" />
                    Sign Out
                </button>
            </div>
        </div>
    );
};

export default DeviceBlockedPage;
